import type { ReactNode } from 'react'

interface PropsType {
  children: ReactNode
  onChange: (e: any) => void
  // TODO: HTMLのvalue属性はstring型なので最終的にnumberは削除する
  value: string | number | null
  ariaLabel?: string
  className?: string
}

const EmphasisSelectBox = (props: PropsType) => {
  const { children, onChange, value, ariaLabel, className = '' } = props
  const safetyValue = value ?? '0'
  return (
    <select className={`ext-select h-9 cursor-pointer pl-3.5 ${className}`} value={safetyValue} onChange={onChange} aria-label={ariaLabel}>
      {children}
    </select>
  )
}

export default EmphasisSelectBox
